import { PIPELINE_SUBSTEPS_STORAGE_KEY } from './pipeline-substeps-storage-key';

export function readShowPipelineSubstepsPreference(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(PIPELINE_SUBSTEPS_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}
